module.exports = __webpack_public_path__ + "static/media/0502localteam-hat.810ca56a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/0502localteam-hat.jpg
// module id = 399
// module chunks = 0